<template>
  <div class="mx-8 mt-10">
    <h2 class="text-center text-3xl font-baskerville">
      Découvrir notre <span class="font-funny text-4xl ml-2">Univers</span>
    </h2>
    <div class="text-center mb-6 text-lg font-geologica font-thin">Nos produits en un coup d'oeil</div>
    <div class="big-container mx-auto mt-4 grid grid-cols-4 gap-2">
      <nuxt-link
        v-for="(category, i) in categories.slice(0, 8)"
        :key="i"
        class="sky__index-category-tile relative"
        :to="$helpers.makeUri(category.path, 'category')"
      >
        <div class="flex justify-center" role="img" :aria-label="`Catégorie ${category.label}`" :style="{aspectRatio: '8/10', backgroundImage: `url(${category.attributes.image_home_page_categorie || category.attributes.home_menu_picture})`, backgroundSize: 'cover', backgroundPosition: 'center'}">
          <h3 class="text-white text-center py-4 text-2xl" style="max-width: 60%; line-height: 1.1;">
            {{ category.label }}
          </h3>
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      required: true,
      type: Array
    }
  }
}
</script>
